export enum ViewingTab {
  UPCOMING = 'UPCOMING',
  PAST = 'PAST'
}
